import { jsx as _jsx } from "react/jsx-runtime";
import { I18nextProvider } from 'react-i18next';
import { useUserLanguage } from '@robinpowered/dashboard-apps-common';
import { i18n } from '../i18n';
export var LocalizationContext = function (_a) {
    var children = _a.children;
    useUserLanguage(i18n.language, i18n.changeLanguage);
    return _jsx(I18nextProvider, { i18n: i18n, children: children });
};
